module.exports = __webpack_public_path__ + "img/codorniu_11.78bb2a1c.png";